(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["race-discount-tracker"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__raceDiscountTrackerLoaded) return;
    window.__raceDiscountTrackerLoaded = true;

    var request = window.fetch ? window.fetch.bind(window) : null;
    var cartMutationPattern = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/;
    var inFlight = Object.create(null);
    var messageState = Object.create(null);
    var lastCart = null;
    var scheduleTimer = null;
    var scheduledWithCart = false;
    var syncRunning = false;
    var syncAgain = false;
    var syncAgainWithCart = false;

    function hasApplyInFlight() {
      return Object.keys(inFlight).length > 0;
    }

    function acquireDiscountMutation(owner) {
      var lock = window.__themeCartDiscountMutationLock;
      if (!lock) {
        lock = { owner: null };
        window.__themeCartDiscountMutationLock = lock;
      }
      if (lock.owner) return false;
      lock.owner = owner;
      return true;
    }

    function releaseDiscountMutation(owner) {
      var lock = window.__themeCartDiscountMutationLock;
      if (lock && lock.owner === owner) lock.owner = null;
    }

    function routeRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function normalizeCode(code) {
      return String(code || '').trim().toLowerCase();
    }

    function trackerRoots() {
      return document.querySelectorAll('[data-race-discount-tracker]');
    }

    function findRowByRace(root, raceId) {
      var match = null;
      if (!root) return match;
      root.querySelectorAll('[data-race-discount-item]').forEach(function (row) {
        if (!match && row.dataset.raceId === String(raceId || '')) match = row;
      });
      return match;
    }

    function sourceMarksRaceExhausted(source, raceId, code) {
      if (!source || !raceId) return false;
      return (
        source.getAttribute('data-race-' + raceId + '-enabled') === 'true' &&
        source.getAttribute('data-race-' + raceId + '-exhausted') === 'true' &&
        normalizeCode(source.getAttribute('data-race-' + raceId + '-code')) === normalizeCode(code)
      );
    }

    function hasVisibleTracker() {
      return Array.prototype.some.call(trackerRoots(), function (tracker) {
        return !tracker.hidden && tracker.getClientRects().length > 0;
      });
    }

    function trackerIsPresented(tracker) {
      if (!tracker || tracker.hidden || tracker.getClientRects().length === 0) return false;
      var cartDrawer = tracker.closest('.tt-cart');
      return !cartDrawer || cartDrawer.classList.contains('active');
    }

    function fetchCart() {
      if (!request) return Promise.reject(new Error('Fetch is unavailable'));
      return request(routeRoot() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      });
    }

    function fetchFragment() {
      if (!request) return Promise.resolve({ loaded: false, source: null });
      var url = routeRoot() + '?section_id=race-discount-tracker&_race=' + Date.now();
      return request(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) throw new Error('Tracker request failed');
        return response.text();
      }).then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        return {
          loaded: true,
          source: parsed.querySelector('[data-race-discount-tracker]')
        };
      }).catch(function () {
        return { loaded: false, source: null };
      });
    }

    function getAppliedCodes(cart) {
      var codes = [];
      var seen = Object.create(null);

      function add(code) {
        var key = normalizeCode(code);
        if (!key || seen[key]) return;
        seen[key] = true;
        codes.push(String(code));
      }

      if (cart && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(function (discount) {
          if (discount && discount.code && discount.applicable !== false) add(discount.code);
        });
      }

      if (cart && Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach(function (application) {
          if (application && application.type === 'discount_code' && application.title) add(application.title);
        });
      }

      if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (allocation) {
            var application = allocation && allocation.discount_application;
            if (application && application.type === 'discount_code' && application.title) add(application.title);
          });
        });
      }

      return codes;
    }

    function hasDiscount(cart, code) {
      var target = normalizeCode(code);
      var found = false;
      if (!cart || !target) return false;

      (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach(function (discount) {
        if (discount && discount.applicable !== false && normalizeCode(discount.code) === target) found = true;
      });

      (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).forEach(function (application) {
        if (application && normalizeCode(application.title) === target) found = true;
      });

      (Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
        (item.discounts || []).forEach(function (discount) {
          if (discount && normalizeCode(discount.title) === target) found = true;
        });
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var application = allocation && allocation.discount_application;
          if (application && normalizeCode(application.title) === target) found = true;
        });
      });

      return found;
    }

    function setMessage(code, text, type, duration) {
      messageState[normalizeCode(code)] = {
        text: text,
        type: type || '',
        expires: Date.now() + duration
      };
    }

    function announce(message, tracker) {
      var region = tracker && tracker.nextElementSibling;
      if (!region || !region.matches('[data-race-discount-announcer]')) {
        region = document.createElement('p');
        region.className = 'race-discount-tracker__announcement';
        region.setAttribute('data-race-discount-announcer', '');
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('aria-atomic', 'true');
        if (tracker && tracker.parentNode) tracker.parentNode.insertBefore(region, tracker.nextSibling);
      }
      if (!region || !region.parentNode) return;
      window.clearTimeout(region.__raceDiscountTimer);
      if (region.__raceDiscountBlurHandler) {
        region.removeEventListener('blur', region.__raceDiscountBlurHandler);
        region.__raceDiscountBlurHandler = null;
      }
      region.hidden = false;
      region.textContent = '';
      var emptyCartWrapper = region.closest('[data-race-empty-cart-tracker]');
      if (emptyCartWrapper) emptyCartWrapper.hidden = false;
      window.setTimeout(function () { region.textContent = message; }, 0);

      function hideAnnouncement() {
        region.hidden = true;
        region.textContent = '';
        region.__raceDiscountBlurHandler = null;
        updateEmptyCartTracker(lastCart);
      }

      region.__raceDiscountTimer = window.setTimeout(function () {
        if (document.activeElement === region) {
          region.__raceDiscountBlurHandler = hideAnnouncement;
          region.addEventListener('blur', hideAnnouncement, { once: true });
          return;
        }
        hideAnnouncement();
      }, 10000);
      return region;
    }

    function focusTemporarily(element) {
      if (!element) return;
      var suppliedTabIndex = element.hasAttribute('tabindex');
      var naturallyFocusable = element.matches(
        'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)'
      );
      if (!suppliedTabIndex && !naturallyFocusable) element.setAttribute('tabindex', '-1');
      element.setAttribute('data-race-focus-fallback', '');
      element.focus();
      element.addEventListener('blur', function () {
        element.removeAttribute('data-race-focus-fallback');
        if (!suppliedTabIndex && !naturallyFocusable) {
          element.removeAttribute('tabindex');
        }
      }, { once: true });
    }

    function focusCartFallback(tracker) {
      var drawer = tracker && tracker.closest('.tt-cart');
      var closeButton = drawer ? drawer.querySelector('.tt-dropdown-menu .tt-close') : null;
      var fallback = drawer
        ? closeButton && closeButton.getClientRects().length > 0
          ? closeButton
          : drawer.querySelector('.tt-dropdown-toggle')
        : document.querySelector(
          '.tt-empty-cart-js:not(.hide) a, #updateform h1, main h1, .tt-title-subpages'
        );
      focusTemporarily(fallback);
    }

    function renderStatus(row) {
      var status = row.querySelector('[data-race-discount-status]');
      var state = messageState[normalizeCode(row.dataset.code)];
      if (!status) return;

      if (!state || state.expires <= Date.now()) {
        if (state) delete messageState[normalizeCode(row.dataset.code)];
        if (!status.hidden) status.hidden = true;
        if (status.textContent) status.textContent = '';
        status.classList.remove('is-error', 'is-success');
        return;
      }

      if (status.hidden) status.hidden = false;
      if (status.textContent !== state.text) status.textContent = state.text;
      status.classList.toggle('is-error', state.type === 'error');
      status.classList.toggle('is-success', state.type === 'success');
    }

    function updateRows(cart) {
      var applyInFlight = hasApplyInFlight();
      document.querySelectorAll('[data-race-discount-item]').forEach(function (row) {
        var code = row.dataset.code || '';
        var key = normalizeCode(code);
        var exhausted = row.dataset.exhausted === 'true';
        var busy = Boolean(inFlight[key]);
        var applied = hasDiscount(cart, code);
        var button = row.querySelector('[data-race-discount-apply]');

        row.classList.toggle('is-applied', applied);
        if (button) {
          var shouldDisable = exhausted || (applyInFlight && !busy);
          var ariaDisabled = shouldDisable || busy || applied ? 'true' : 'false';
          var ariaBusy = busy ? 'true' : 'false';
          var ariaLabel = busy
            ? row.dataset.applyingMessage
            : applied
              ? row.dataset.appliedMessage
              : button.dataset.applyAriaLabel;
          var buttonLabel = busy
            ? row.dataset.applyingLabel
            : applied
              ? row.dataset.appliedLabel
              : row.dataset.applyLabel;
          if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
          if (button.getAttribute('aria-disabled') !== ariaDisabled) {
            button.setAttribute('aria-disabled', ariaDisabled);
          }
          if (button.getAttribute('aria-busy') !== ariaBusy) button.setAttribute('aria-busy', ariaBusy);
          if (button.getAttribute('aria-label') !== ariaLabel) button.setAttribute('aria-label', ariaLabel);
          if (button.textContent !== buttonLabel) button.textContent = buttonLabel;
        }
        renderStatus(row);
      });
    }

    function updateEmptyCartTracker(cart) {
      if (!cart) return;
      document.querySelectorAll('[data-race-empty-cart-tracker]').forEach(function (wrapper) {
        var tracker = wrapper.querySelector('[data-race-discount-tracker]');
        var announcement = wrapper.querySelector('[data-race-discount-announcer]:not([hidden])');
        wrapper.hidden = cart.item_count > 0 || ((!tracker || tracker.hidden) && !announcement);
      });
    }

    function replaceFragments(source) {
      var active = document.activeElement;
      var activeRow = active && active.closest ? active.closest('[data-race-discount-item]') : null;
      var activeCode = activeRow ? activeRow.dataset.code : '';
      var activeRaceId = activeRow ? activeRow.dataset.raceId : '';
      var activeRoot = activeRow ? activeRow.closest('[data-race-discount-tracker]') : null;
      var activeContext = activeRoot ? activeRoot.dataset.context : '';
      var activeWasAvailable = activeRow ? activeRow.dataset.exhausted !== 'true' : false;
      var exhaustedMessage = activeRow ? activeRow.dataset.exhaustedMessage : '';
      var exhaustionNotices = [];
      var changed = false;

      trackerRoots().forEach(function (target) {
        var previouslyAvailable = [];
        if (trackerIsPresented(target)) {
          target.querySelectorAll('[data-race-discount-item]').forEach(function (row) {
            if (row.dataset.exhausted !== 'true') {
              previouslyAvailable.push({
                raceId: row.dataset.raceId,
                code: row.dataset.code,
                message: row.dataset.exhaustedMessage
              });
            }
          });
        }

        if (!source) {
          if (!target.hidden) {
            target.hidden = true;
            changed = true;
          }
          return;
        }
        if (
          target.dataset.raceSignature === source.dataset.raceSignature &&
          target.hidden === source.hidden &&
          target.style.cssText === source.style.cssText
        ) return;

        target.innerHTML = source.innerHTML;
        target.hidden = source.hidden;
        target.dataset.raceSignature = source.dataset.raceSignature || '';
        target.style.cssText = source.style.cssText;
        changed = true;

        var messages = [];
        previouslyAvailable.forEach(function (offer) {
          var currentRow = findRowByRace(target, offer.raceId);
          if (
            (!currentRow || currentRow.dataset.exhausted === 'true') &&
            sourceMarksRaceExhausted(source, offer.raceId, offer.code)
          ) messages.push(offer.message);
        });
        if (messages.length) exhaustionNotices.push({ tracker: target, messages: messages });
      });

      exhaustionNotices.forEach(function (notice) {
        announce(notice.messages.join(' '), notice.tracker);
      });

      if (changed && activeRaceId) {
        window.setTimeout(function () {
          var replacementRoot = activeRoot && document.documentElement.contains(activeRoot)
            ? activeRoot
            : null;
          if (!replacementRoot) {
            trackerRoots().forEach(function (root) {
              if (!replacementRoot && root.dataset.context === activeContext && !root.hidden) {
                replacementRoot = root;
              }
            });
          }

          var replacementRow = findRowByRace(replacementRoot, activeRaceId);
          var replacementButton = replacementRow
            ? replacementRow.querySelector('[data-race-discount-apply]')
            : null;
          if (replacementButton && !replacementButton.disabled && !replacementRoot.hidden) {
            replacementButton.focus();
            return;
          }

          var becameExhausted = activeWasAvailable && sourceMarksRaceExhausted(
            source,
            activeRaceId,
            activeCode
          );
          var region = replacementRoot ? replacementRoot.nextElementSibling : null;
          if (
            becameExhausted &&
            exhaustedMessage &&
            (!region || !region.matches('[data-race-discount-announcer]') || region.hidden)
          ) region = announce(exhaustedMessage, replacementRoot);
          var nextButton = replacementRoot && !replacementRoot.hidden
            ? replacementRoot.querySelector('[data-race-discount-apply]:not(:disabled)')
            : null;
          if (nextButton) {
            nextButton.focus();
          } else if (replacementRoot && !replacementRoot.hidden) {
            focusTemporarily(replacementRoot);
          } else {
            focusCartFallback(activeRoot || replacementRoot);
          }
        }, 0);
      }
    }

    function finishSync() {
      syncRunning = false;
      if (!syncAgain) return;
      var includeCart = syncAgainWithCart;
      syncAgain = false;
      syncAgainWithCart = false;
      runSync(includeCart);
    }

    function runSync(includeCart) {
      if (!trackerRoots().length) return;
      if (window.Shopify && window.Shopify.designMode) {
        if (!includeCart) {
          updateRows(lastCart || {});
          return;
        }
        fetchCart().then(function (cart) {
          lastCart = cart;
          updateEmptyCartTracker(cart);
          updateRows(cart);
        }, function () {
          updateRows(lastCart || {});
        });
        return;
      }
      if (syncRunning) {
        syncAgain = true;
        syncAgainWithCart = syncAgainWithCart || includeCart;
        return;
      }

      syncRunning = true;
      var cartRequest = includeCart
        ? fetchCart().catch(function () { return null; })
        : Promise.resolve(lastCart);

      Promise.all([fetchFragment(), cartRequest]).then(function (results) {
        var fragment = results[0];
        var cart = results[1];
        if (fragment.loaded) replaceFragments(fragment.source);
        if (cart) {
          lastCart = cart;
          updateEmptyCartTracker(cart);
        }
        updateRows(lastCart || {});
      }).then(finishSync, finishSync);
    }

    function scheduleSync(includeCart) {
      scheduledWithCart = scheduledWithCart || includeCart;
      window.clearTimeout(scheduleTimer);
      scheduleTimer = window.setTimeout(function () {
        var needsCart = scheduledWithCart;
        scheduledWithCart = false;
        runSync(needsCart);
      }, 160);
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents, window.money_format || window.Shopify.money_format);
        } catch (error) {}
      }
      return '$' + (Math.round(cents || 0) / 100).toFixed(2);
    }

    function updateTotals(cart) {
      var total = formatMoney(cart.total_price);
      document.querySelectorAll('[data-hulkapps-cart-total]').forEach(function (element) {
        element.dataset.totalPrice = cart.total_price;
        if (!element.hasAttribute('data-cart-page-total')) element.textContent = total;
      });
      document.querySelectorAll('.dropdown-checkout-total').forEach(function (element) {
        element.textContent = total;
      });
      document.querySelectorAll('.dropdown-estimated-total-value').forEach(function (element) {
        element.innerHTML = '<strong>' + total + '</strong>';
      });
    }

    function postDiscount(codes) {
      if (!request) return Promise.reject(new Error('Fetch is unavailable'));
      return request(routeRoot() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (response) {
        if (!response.ok) throw new Error('Discount request failed');
        return response.json();
      });
    }

    function applyCode(row) {
      var code = row.dataset.code || '';
      var key = normalizeCode(code);
      if (
        !key ||
        row.dataset.exhausted === 'true' ||
        hasApplyInFlight() ||
        hasDiscount(lastCart || {}, code)
      ) return;
      var originTracker = row.closest('[data-race-discount-tracker]');
      var raceId = row.dataset.raceId || '';
      var mutationOwner = {};

      var messages = {
        applying: row.dataset.applyingMessage,
        applied: row.dataset.appliedMessage,
        invalid: row.dataset.invalidMessage,
        error: row.dataset.errorMessage,
        exhausted: row.dataset.exhaustedMessage
      };

      function finishApply() {
        releaseDiscountMutation(mutationOwner);
        delete inFlight[key];
        updateRows(lastCart || {});
        scheduleSync(false);
      }

      if (!acquireDiscountMutation(mutationOwner)) {
        setMessage(code, messages.error, 'error', 5000);
        updateRows(lastCart || {});
        return;
      }

      inFlight[key] = true;
      setMessage(code, messages.applying, '', 120000);
      updateRows(lastCart || {});

      fetchFragment().then(function (fragment) {
        if (!fragment.loaded) throw new Error('Tracker request failed');
        var currentRow = findRowByRace(fragment.source, raceId);
        var freshExhausted = sourceMarksRaceExhausted(fragment.source, raceId, code);
        if (!(window.Shopify && window.Shopify.designMode)) {
          replaceFragments(fragment.source);
        }
        updateEmptyCartTracker(lastCart);
        updateRows(lastCart || {});
        if (!currentRow || currentRow.dataset.exhausted === 'true') {
          var region = originTracker ? originTracker.nextElementSibling : null;
          if (
            (!region || !region.matches('[data-race-discount-announcer]') || region.hidden)
          ) announce(freshExhausted ? messages.exhausted : messages.error, originTracker);
          return null;
        }
        if (
          normalizeCode(currentRow.dataset.code) !== key ||
          !currentRow.querySelector('[data-race-discount-apply]')
        ) {
          var configRegion = originTracker ? originTracker.nextElementSibling : null;
          if (
            !configRegion ||
            !configRegion.matches('[data-race-discount-announcer]') ||
            configRegion.hidden
          ) announce(messages.error, originTracker);
          return null;
        }
        return fetchCart();
      }).then(function (cart) {
        if (!cart) return null;
        if (hasDiscount(cart, code)) return cart;
        var appliedCodes = getAppliedCodes(cart);
        var alreadyIncluded = appliedCodes.some(function (appliedCode) {
          return normalizeCode(appliedCode) === key;
        });
        if (!alreadyIncluded) appliedCodes.push(code);
        return postDiscount(appliedCodes).then(fetchCart);
      }).then(function (cart) {
        if (!cart) return;
        lastCart = cart;
        updateEmptyCartTracker(cart);
        if (hasDiscount(cart, code)) {
          setMessage(code, messages.applied, 'success', 10000);
        } else {
          setMessage(code, messages.invalid, 'error', 10000);
        }
        updateTotals(cart);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, function () {
        setMessage(code, messages.error, 'error', 10000);
      }).then(finishApply, function () {
        setMessage(code, messages.error, 'error', 10000);
        finishApply();
      });
    }

    function wrapCartRequests() {
      if (window.fetch && !window.__raceDiscountFetchWrapped) {
        window.__raceDiscountFetchWrapped = true;
        var originalFetch = window.fetch;
        window.fetch = function (resource) {
          var url = '';
          try {
            url = typeof resource === 'string' ? resource : resource && resource.url || '';
          } catch (error) {}
          var response = originalFetch.apply(window, arguments);
          if (cartMutationPattern.test(url)) {
            response.then(function () { scheduleSync(true); }, function () {});
          }
          return response;
        };
      }

      if (window.XMLHttpRequest && !window.__raceDiscountXhrWrapped) {
        window.__raceDiscountXhrWrapped = true;
        var originalOpen = window.XMLHttpRequest.prototype.open;
        var originalSend = window.XMLHttpRequest.prototype.send;
        window.XMLHttpRequest.prototype.open = function (method, url) {
          this.__raceDiscountUrl = url || '';
          return originalOpen.apply(this, arguments);
        };
        window.XMLHttpRequest.prototype.send = function () {
          if (cartMutationPattern.test(this.__raceDiscountUrl || '')) {
            this.addEventListener('loadend', function () { scheduleSync(true); });
          }
          return originalSend.apply(this, arguments);
        };
      }
    }

    function bindThemeEvents() {
      if (!window.jQuery) return;
      window.jQuery('body')
        .off('refreshCurrency.raceDiscountTracker')
        .on('refreshCurrency.raceDiscountTracker', function () { scheduleSync(true); });
    }

    function onReady() {
      if (!trackerRoots().length) return;
      wrapCartRequests();
      bindThemeEvents();
      runSync(true);

      document.addEventListener('click', function (event) {
        var applyButton = event.target.closest('[data-race-discount-apply]');
        if (applyButton) {
          event.preventDefault();
          var row = applyButton.closest('[data-race-discount-item]');
          if (row) applyCode(row);
          return;
        }

        if (event.target.closest('.tt-cart .tt-dropdown-toggle')) scheduleSync(true);
      });

      document.addEventListener('cart:updated', function () { scheduleSync(true); });
      document.addEventListener('shopify:section:load', function () { scheduleSync(true); });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') scheduleSync(false);
      });
      window.addEventListener('pageshow', function () { scheduleSync(true); });

      var observer = new MutationObserver(function (mutations) {
        var addedTracker = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) return false;
            return node.matches('[data-race-discount-tracker]') ||
              Boolean(node.querySelector('[data-race-discount-tracker]'));
          });
        });
        if (addedTracker) scheduleSync(true);
      });
      observer.observe(document.body, { childList: true, subtree: true });

      window.setInterval(function () {
        if (
          document.visibilityState === 'visible' &&
          hasVisibleTracker()
        ) scheduleSync(false);
      }, 30000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    window.RaceDiscountTracker = {
      refresh: function () { scheduleSync(true); }
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
